import cn from 'classnames';

import { CheckMark, Cross } from '@webapp/common/assets/icons';
import { NotificationModal } from '@webapp/common/components/notification-modal';
import { setHtml } from '@webapp/common/lib/ui';

import css from './test-answer-modal.css';

interface Props {
    testAnswerCorrectText: string;
    testAnswerIncorrectText: string;
    correct: boolean;
    onClose: () => void;
}

export const TestAnswerModal: FC<Props> = ({ testAnswerCorrectText, testAnswerIncorrectText, correct, onClose }) => {
    return (
        <NotificationModal onClose={onClose}>
            <div className={cn(css.content, { [css.correct]: correct, [css.incorrect]: !correct })}>
                <span className={css.iconWrap}>
                    {correct ? <CheckMark className={css.iconCorrect} /> : <Cross className={css.iconIncorrect} />}
                </span>
                <div className={css.text} {...setHtml(correct ? testAnswerCorrectText : testAnswerIncorrectText)}></div>
                <span className={css.continue} onClick={onClose}>
                    Продолжить
                </span>
            </div>
        </NotificationModal>
    );
};
